import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Wrapper = styled.div`
  margin-top: -8px !important;
`;

export const CalendarRankDays = () => {
  const starRank = useSelector((state) => state.users.opscore?.rating?.rating) || "N/A";

  const f3 = useSelector((state) => state.config?.opscore);

  const rankInfo = f3.find((item) => item.starRank === starRank);

  return <Wrapper>{rankInfo ? <p>{rankInfo.wording}</p> : null}</Wrapper>;
};

export default CalendarRankDays;
